import React from 'react';
import { Outlet } from 'react-router-dom';
import Notify from '../components/Notify';

export default function Outer() {
  return (
    <>
      <Notify />
      <Outlet />
    </>
  );
}
